(() => {
  if (typeof window.customElements.get('featured-cards') !== 'undefined') { return }

  window.customElements.define('featured-cards', class FeaturedCards extends HTMLElement { // eslint-disable-line
    constructor() {
      super()
      this.swiper = this.querySelector('[data-swiper]')
      this.init()
    }

    async init() {
      const swiper = new Swiper(this.swiper, {
        loop: false,
        slidesPerView: 'auto',
        threshold: 10,
        noSwiping: false,
        draggable: true,
        breakpoints: {
          768: {
            enabled: false
          }
        }
      })

      return swiper
    }
  })
})()
